import AvailabilitySchedule from "./AvailabilitySchedule";

export default AvailabilitySchedule;
